import { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import MetaHead from '../components/MetaHead';
import Layout from '../components/layouts/Layout';
import termsOfServiceHtml from '../components/policies/terms-of-service';

const TermsUsePage: FC<BootstrapPageProps> = () => (
  <>
    <MetaHead
      title="Terms of Use | Wave.video"
      description="This page explains the terms by which you may use our online services and website."
    />
    <Layout navigationVariant="white" mainVariant="contain">
      <div dangerouslySetInnerHTML={{ __html: termsOfServiceHtml }} />
    </Layout>
  </>
);

export default bootstrapPage(TermsUsePage);
